module.exports = __webpack_public_path__ + "static/1-tyndarasin-660715436130278d6e6273b4cc26a23e.jpg";